import { Button, IconButton } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

export const columns = ({
  fetchDetails,
  isDetail = true,
  fetchBillDocument,
} = {}) => [
  {
    field: "bill_id",
    headerName: "Id",
    width: 150,
    renderCell: (e) =>
      !isDetail ? (
        <Button onClick={() => fetchDetails?.(e.value)} variant="text">
          {e.value}
        </Button>
      ) : (
        <div>{e.value}</div>
      ),
  },
  {
    field: "patient_id",
    headerName: "Patient Id",
    width: 150,
  },
  {
    field: "bill_account_number",
    headerName: "Bill Invoice Id",
    width: 150,
  },
  {
    field: "first_name",
    headerName: "Patient Name",
    width: 200,
    renderCell: (e) => <div>{e.value + " " + e.row.last_name}</div>,
  },
  {
    field: "billing_amount",
    headerName: "Amount",
    width: 150,
  },
  {
    field: "bill_date",
    headerName: "Bill Date",
    width: 150,
    valueFormatter: (value) => (value ? dayjs(value).format("MM/DD/YYYY") : ""),
  },
  {
    field: "status",
    headerName: "Status",
    width: 150,
    align: "center",
  },
  {
    field: "download",
    headerName: " ",

    minWidth: 250,
    flex: 1,
    renderCell: (e) =>
      fetchBillDocument && (
        <IconButton
          onClick={() => fetchBillDocument(e.row.bill_id)}
          size="small"
        >
          <PictureAsPdfIcon color="secondary" />
        </IconButton>
      ),
  },
];

export const statusOptions = [
  "Bill Paid",
  "Bill Void",
  "Bill Generated",
  "Bill Partially Paid",
  "Bill Sent",
];
